import React from 'react'
import BotonSimple from '../Botones/BotonSimple'

const PaginacionAnteriorSiguiente = ({
  paginaActual,
  totalPaginas,
  tamanoPagina,
  cantidadEnPagina,
  funcionIrAPagina,
}) => {
  const paginaActualSegura = paginaActual ?? 1
  const totalPaginasSeguro = totalPaginas ?? paginaActualSegura
  const tamanoSeguro = tamanoPagina ?? 0
  const cantidadSegura = cantidadEnPagina ?? 0

  const hayMasPaginas = totalPaginasSeguro > paginaActualSegura
  const puedeIrAtras = paginaActualSegura > 1

  const desde = cantidadSegura > 0 ? (paginaActualSegura - 1) * tamanoSeguro + 1 : 0
  const hasta = cantidadSegura > 0 ? (paginaActualSegura - 1) * tamanoSeguro + cantidadSegura : 0

  const textoRango = cantidadSegura > 0
    ? hayMasPaginas
      ? `Mostrando ${desde} - ${hasta} de muchos`
      : `Mostrando ${desde} - ${hasta}`
    : 'Sin resultados'

  const irAnterior = () => {
    if (puedeIrAtras) {
      funcionIrAPagina(paginaActualSegura - 1)
    }
  }

  const irSiguiente = () => {
    if (hayMasPaginas) {
      funcionIrAPagina(paginaActualSegura + 1)
    }
  }

  const estiloFlecha = (habilitado) =>
    `text-5xl ml-2 relative inline-flex items-center pb-3 ${
      habilitado
        ? 'text-cendiatra-gris-1 hover:text-cendiatra-gris-3 cursor-pointer'
        : 'text-cendiatra-gris-2 opacity-50 cursor-not-allowed'
    }`

  return (
    <div className="w-full flex justify-center items-center m-5 h-10">
      <div className="flex items-center">
        <BotonSimple
          texto={'‹'}
          estilosBoton={estiloFlecha(puedeIrAtras)}
          tipoDeBoton={'button'}
          funcion={irAnterior}
        />
        <span className="text-cendiatra-gris-1 text-sm font-medium px-6">
          {textoRango}
        </span>
        <BotonSimple
          texto={'›'}
          estilosBoton={estiloFlecha(hayMasPaginas)}
          tipoDeBoton={'button'}
          funcion={irSiguiente}
        />
      </div>
    </div>
  )
}

export default PaginacionAnteriorSiguiente
